// extracted by mini-css-extract-plugin
export default {"presharedKeyAuthentication":"PresharedKeyAuthentication_presharedKeyAuthentication__NFmGy"};